<template>
  <div
    class="relative overflow-hidden rounded-[2rem] border border-zinc-200/70 bg-white dark:border-zinc-800 dark:bg-zinc-900/90"
  >
    <slot />
  </div>
</template>

<script>
export default {
  //
}
</script>
